<template lang="html">
  <div class="container-fluid">
    <b-aside
      :is-show="menuOpen"
      title="Ciência-Ação Administração"
      @close="toggleMenu"
      :show-footer="false"
      class="app-aside"
    >
      <menus class="main-menu">
        <menu-item :to="`/${$route.params.lang}/places`" @click.native="toggleMenu">Lugares</menu-item>
        <menu-item :to="`/${$route.params.lang}/users`" @click.native="toggleMenu" v-if="me.role !== 'moderator'">Usuários</menu-item>
      </menus>

      <lang-switcher :on-lang-switch="toggleMenu" />

    </b-aside>

    <div class="columns is-gapless main">
      <!-- main content -->
      <div class="column is-12 main">
        <button class="button is-large is-white is-pulled-left" @click="toggleMenu()">
          <span class="icon"><i class="fa fa-bars"></i></span>
        </button>

        <usermenu class="is-pulled-right" />

        <div class="main-content">
          <slot></slot>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import usermenu from '../user/user-menu-component.vue'
import LangSwitcher from '../LangSwitcher'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Layout',

  components: { usermenu, LangSwitcher },

  data () {
    return {
      isShow: false,
      asideShow: false
    }
  },
  mounted () {
    this.RetrieveProfile({ force: true })
      .then(
        success => {
          if (success.role === 'user') {
            this.$notify.open({
              type: 'danger',
              content: 'Acesso negado: Seu usuário não tem acesso à administração.',
              duration: 10000
            })
            this.$router.push('/logout')
          }
        },
        error => {
          console.log(error.response)
          this.$router.push(`/logout`)
        }
      )
    this.RetrieveCategories({ force: true })
      .then(
        success => false,
        error => {
          console.log(error.response)
          this.$notify.open({
            type: 'danger',
            content: 'Não foi possível obter as categorias',
            duration: 10000
          })
        }
      )
  },

  computed: {
    ...mapGetters(['menuOpen', 'me'])
  },

  methods: {
    ...mapActions(['RetrieveProfile', 'toggleMenu', 'RetrieveCategories']),
    toggle () {
      this.isShow = !this.isShow
    }
  }
}
</script>

<style lang="scss">
  .container-fluid {
    background: #fff;
  }

  .columns.main {
    min-height: 100vh;
  }

  .breadcrumb {
    margin-bottom: 30px;
  }

  .the-content {
    margin-bottom: 30px;
    margin-top: 30px;
  }

  /**
   * Header Nav
   */
   .header-nav {
    padding: 5px 15px;
   }

  /**
   * Main Content
   */
  .main-content {
    padding: 30px 20px;
    clear: both;
    background: #f5f5f5;
  }

  .is-danger, a.is-danger {
    color: red;
  }

  .is-block {
    display: block !important;
  }
  .is-block.is-centered {
      margin-right: auto !important;
      margin-left: auto !important;
  }
  .app-aside {
    .aside-body {
      display: flex;
      flex-direction: column;
    }
    .main-menu {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/layout.vue